import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[blockEmoticons]',
    standalone: false
})
export class BlockEmoticonsDirective {
	constructor() {}

	@HostListener('input', ['$event']) regexEmoticonInput(event: any) {
		if (event.target && event.target.value)
			// Permitir letras (con acentos), números, espacios, nueva línea y puntuación común; bloquear emojis/otros símbolos
			event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s\náàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑüÜñÑ¿¡°#\-.,;:!\?@_~\/'"()\[\]{}+*&%$=|<>\\]/gm, '');
	}

	@HostListener('paste', ['$event']) regexEmoticonPaste(event: any) {
		if (event.target && event.target.value)
			// Igual que en input: permitir puntuación y saltos de línea
			event.target.value = event.target.value.replace(/[^a-zA-Z0-9\s\náàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑüÜñÑ¿¡°#\-.,;:!\?@_~\/'"()\[\]{}+*&%$=|<>\\]/gm, '');
	}
}
